module.exports = __webpack_public_path__ + "fee54119acfd0b0a2ab2e17c2fcfa1a0.pdf";